import { render } from "./NoDataMessage.vue?vue&type=template&id=3f43b294&scoped=true"
import script from "./NoDataMessage.vue?vue&type=script&lang=js"
export * from "./NoDataMessage.vue?vue&type=script&lang=js"

import "./NoDataMessage.vue?vue&type=style&index=0&id=3f43b294&lang=scss&scoped=true"

import exportComponent from "/Applications/dev/FLEXX_FREIGHT/flexx-freight-stats/website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f43b294"]])

export default __exports__